import baseRequest from "../_core/baseRequest";

export default {
    transfers: params => baseRequest.get(`transfer/`, params),
    transferRegions: params => baseRequest.get(`transfer/getTransferRegions`, params),
    transferCenters: params =>
        baseRequest.get(
            `transfer/getTransferCenter${
                Object.keys(params).length > 0 ? `?type=${params.type}&owner=${params.owner}` : ""
            }`,
            params
        ),
    transferGroups: params =>
        baseRequest.get(
            `transfer/getTransferGroup?page=${params.page}&limit=${params.limit}${
                params.fromId ? `&fromId=${params.fromId}` : ""
            }${params.toId ? `&toId=${params.toId}` : ""}${
                params.status ? `&status=${params.status}` : ""
            }`,
            params
        ),
    activeTransfers: params =>
        baseRequest.get(
            `transfer/activeTransfers?page=${params.page}&limit=${params.limit}${
                params.fromId ? `&fromId=${params.fromId}` : ""
            }${params.toId ? `&toId=${params.toId}` : ""}`,
            params
        ),
    createTransferReference: params => baseRequest.post(`transfer/transferReference`, params),
    createRotation: params => baseRequest.post(`transfer/calculateTransferReference`, params),
    createTransferWithReference: params =>
        baseRequest.post(`transfer/createTransferWithReference`, params),
    getTransferReference: params =>
        baseRequest.get(
            `transfer/getTransferReference${
                params.id
                    ? params.status
                        ? `?id=${params.id}&status=${String(params.status)}`
                        : `?id=${params.id}`
                    : params.status
                    ? `?status=${String(params.status)}`
                    : ""
            }${
                params.page && params.limit
                    ? `${params.id || params.status ? "&" : "?"}page=${params.page}&limit=${
                          params.limit
                      }`
                    : ""
            }`,
            params
        ),
    returnTranferReferenceEdit: params =>
        baseRequest.post(`transfer/returnTransferReferenceEdit`, params),
    updateTransferGroup: params => baseRequest.post(`transfer/updateTransferGroup`, params),
    moveShipment: params => baseRequest.post(`transfer/moveShipmentToTransfer`, params),
    acceptableMoveTransferPackets: params =>
        baseRequest.get(
            `transfer/acceptableMoveTransferPackets?transferId=${params.transferId}`,
            params
        ),
    shipmentTransferGroupList: params =>
        baseRequest.get(
            `transfer/shipmentTransferGroup?page=${params.page}&limit=${params.limit}${
                params.shipmentNumber ? `&shipmentNumber=${params.shipmentNumber}` : ""
            }${params.groupName ? `&groupName=${params.groupName}` : ""}${
                params.startDate ? `&startDate=${params.startDate}` : ""
            }${params.endDate ? `&endDate=${params.endDate}` : ""}${
                params.date ? `&date=${params.date}` : ""
            }${params.transferCenter ? `&transferCenter=${params.transferCenter}` : ""}${
                params.groupStatus ? `&groupStatus=${params.groupStatus}` : ""
            }${params.warehouseStatus ? `&warehouseStatus=${params.warehouseStatus}` : ""}${
                params.deliveryStatus ? `&deliveryStatus=${params.deliveryStatus}` : ""
            }${params.missingStatus ? `&missingStatus=${params.missingStatus}` : ""}`,
            params
        ),
    transferGroupShipmentList: params =>
        baseRequest.get(
            `transfer/transferGroupShipment?page=${params.page}&limit=${params.limit}${
                params.groupId ? `&groupId=${params.groupId}` : ""
            }${params.shipmentNumber ? `&shipmentNumber=${params.shipmentNumber}` : ""}${
                params.warehouseStatus ? `&warehouseStatus=${params.warehouseStatus}` : ""
            }${params.deliveryStatus ? `&deliveryStatus=${params.deliveryStatus}` : ""}${
                params.missingStatus ? `&missingStatus=${params.missingStatus}` : ""
            }`,
            params
        ),
    transferShipmentActivities: params =>
        baseRequest.get(`transfer/shipmentActivity?shipmentId=${params.shipmentId}`, params),
    updateTransferGroupCutOff: params => baseRequest.put(`transfer/transferGroupCutOff`, params),
    undeliveredShipments: params =>
        baseRequest.get(
            `transfer/unDeliveredShipment?page=${params.page}&limit=${params.limit}${
                params.shipmentNumber ? `&shipmentNumber=${params.shipmentNumber}` : ""
            }${params.startDate ? `&startDate=${params.startDate}` : ""}${
                params.endDate ? `&endDate=${params.endDate}` : ""
            }`,
            params
        ),
    scheduleNextDay: params => baseRequest.post(`transfer/scheduleNextDay`, params),
    sendBackToCompany: params => baseRequest.post(`transfer/sendBackToCompany`, params),
    transferCenterList: params =>
        baseRequest.get(
            `transfer/transferCenter?page=${params.page}&limit=${params.limit}${
                params.date ? `&date=${params.date}` : ""
            }${params.status ? `&status=${params.status}` : ""}${
                params.city ? `&city=${params.city}` : ""
            }${params.district ? `&district=${params.district}` : ""}${
                params.supplierId ? `&supplierId=${params.supplierId}` : ""
            }`,
            params
        ),
    updateTransferCenterStatus: params => baseRequest.put(`transfer/transferCenter`, params),
    createTransferCenter: params => baseRequest.post(`transfer/transferCenter`, params),
    acceptableMoveTransfer: params =>
        baseRequest.get(`transfer/acceptableMoveTransfer?transferId=${params.transferId}`, params),
    moveShipmentToTransfer: params => baseRequest.post(`transfer/moveShipmentToTransfer`, params),
    moveShipmentToNewTransfer: params =>
        baseRequest.post(`transfer/moveShipmentToNewTransfer`, params)
};
